import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { angleLeft } from '@primeicons/core/angle-left';

@Component({
    selector: 'svg[data-p-icon="angle-left"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class AngleLeft extends CoreIcon {
    constructor() {
        super();
        this._icon = angleLeft;
    }
}
